// src/shared/components/Spinner.js
import React from 'react';
import { Loader } from 'lucide-react';

const Spinner = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  };

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <Loader className={`animate-spin ${sizes[size]} text-blue-600`} />
    </div>
  );
};

export default Spinner;